import { put, call } from "redux-saga/effects";
import {       GET_PDFINFO_SUCESS,GET_PDFINFO_FAILED 
} from "../actions/testPdfViewer";
import { UserAPI } from "../../utils/api/CreateUserAPI";
export function*getPdfView (request:any) {
    try {
        const { data } = yield call(UserAPI.getPdfView,request);
 
    
       //
      yield put({
          type: GET_PDFINFO_SUCESS,
          payload: data 
        });
    } catch (e) {
        yield put({ type: GET_PDFINFO_FAILED, payload: e.message });
    }
}